import { Component, OnInit } from '@angular/core';
import { ValidationService } from '../../../shared/services/validation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../../shared/services/session.service';
import { WhatIsPaycellComponent } from '../../../shared/notification/what-is-paycell/what-is-paycell.component';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TextService } from '../../../shared/services/text.service';
import { SdkInitText } from 'src/app/model/user/sdk-init-text';
import { MessageService } from '../../../shared/services/message-service';
import { NetmeraService } from "../../../shared/services/netmera-service";
import { TelNoGiris } from "../../../model/netmera-events/tel-no-giris";
import { PaycellNedir } from "../../../model/netmera-events/paycell-nedir";

@Component({
  selector: 'pa-phone-login',
  templateUrl: './phone-login.component.html',
  styleUrls: ['./phone-login.component.scss']
})
export class PhoneLoginComponent implements OnInit {
  tplModal: NzModalRef;
  phoneLoginForm = new FormGroup({
    phoneNumber: new FormControl('', [Validators.required, Validators.pattern('^5[0-9]{9}$')])
  });
  errorMessage: string;
  textService: TextService;
  trackingId: string;
  merchantCode: string;
  sdkInitTexts: Array<SdkInitText>;
  validMsisdn: boolean = false;
  isLoginWebSdk: boolean = false;
  buttonName: string;
  loginDescription: string;
  loginDescriptionContinue: string;

  constructor(private router: Router, private route: ActivatedRoute, private validationService: ValidationService, private sessionService: SessionService,
              private modalService: NzModalService, textService: TextService, private messageService: MessageService,
              private netmeraService: NetmeraService, private telNoGiris: TelNoGiris, private paycellNedir: PaycellNedir) {
  this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
      this.sessionService.getInitUser(this.trackingId).subscribe(response => {
        this.sdkInitTexts = response.sdkInitTexts;
        this.merchantCode = response?.requestHeader?.merchant?.merchantCode;
        this.isLoginWebSdk = response.loginWebSdk;
        this.assignToFormIfMsisdnValid(response?.msisdn);
        this.setInitTexts();
      }, error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
    });
  }

  createTplModal(): void {
    this.netmeraService.pushEvent(this.paycellNedir.setEventObject("PaycellNedirAcildi", this.merchantCode));
    this.messageService.setSdkInitTexts(this.sdkInitTexts);
    this.tplModal = this.modalService.create({
      nzClassName: 'what-is-modal',
      nzWrapClassName: 'button:focus',
      nzContent: WhatIsPaycellComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzStyle: {
        width: '513px',
        height: '589px',
        'border-radius': '15px',
        'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)',
        'background-color': '#ffffff'
      }
    });
  }

  checkPhoneNumber() {
    this.netmeraService.pushEvent(this.telNoGiris.setEventObject("TelNoGiris", this.merchantCode));
    if (this.phoneLoginForm.invalid) {
      return;
    }
    this.validationService.checkPhoneNumber(this.phoneLoginForm.value.phoneNumber, this.trackingId).subscribe(response => {
      this.router.navigate(['/route', this.trackingId]);
    }, error => {
      if (error.status == 422) {
        this.errorMessage = error.error.message;
      } else {
        this.router.navigate(['/result/error', this.trackingId]);
      }
    });
  }

  assignToFormIfMsisdnValid(msisdn: string) {
    if (!!msisdn) {
      this.phoneLoginForm.patchValue({
        phoneNumber: msisdn
      })
      this.validMsisdn = true;
    }
  }

  setInitTexts() {
    if (this.isLoginWebSdk) {
      this.buttonName = this.textService.keyValueMapping('loginButtonForTfs', 'Onayla', this.sdkInitTexts);
      this.loginDescription = this.textService.keyValueMapping('loginDescriptionForTfs', 'Aşağıda yer alan ', this.sdkInitTexts);
      this.loginDescriptionContinue = this.textService.keyValueMapping('loginDescriptionContinueForTfs', 'cep telefon numaranız ile işleminize devam edebilirsiniz.', this.sdkInitTexts);
    } else {
      this.buttonName = this.textService.keyValueMapping('loginButton', 'Giriş Yap', this.sdkInitTexts);
      this.loginDescription = this.textService.keyValueMapping('loginDescription', 'Aşağıdaki alana size ait', this.sdkInitTexts);
      this.loginDescriptionContinue = this.textService.keyValueMapping('loginDescriptionContinue', 'cep telefonu numaranızı girin.', this.sdkInitTexts);
    }
  }

  messageState(value: any) {
    this.errorMessage = value;
  }

}
